export const EDITION_BT_LINK = "/";
export const EDITION_BTG_LINK = "/global";
